export const ApplicationConstants = {
  api: {
    getOpportunitiesEndpoint: '/api/Opportunity/GetOpportunities',
    getOpportunityTableDataEndpoint: '/api/Opportunity/GetOpportunityTableData',
    postSubscribeToOppEndpoint: '/api/Opportunity/SubscribeToOpp',
    postUnsubscribeFromOppEndpoint: '/api/Opportunity/UnsubscribeFromOpp',
  },
};
